// El merge {…customer, …agent} de featchGetInfoAgent deja state.agent.name = customer.name = línea WhatsApp activa.
export const getActiveLineName = (agent) => agent?.name || '';
